<template>
  <v-dialog v-model="paymentForm" persistent width="500">
    <v-card tile>
      <v-card-title class="headline">{{ $t("paymentFormTitle") }}</v-card-title>
      <v-card-text>
        <v-text-field
          :label="$t('paymentFormPurchase') + ' *'"
          dense
          type="number"
          maxlength="10"
          required
          v-model="payment.purchase"
          class="mt-4"
          :error-messages="paymentPurchaseErrors"
          @input="$v.payment.purchase.$touch()"
          @blur="$v.payment.purchase.$touch()"
        ></v-text-field>
        <v-text-field
          :label="$t('paymentFormExternal')"
          dense
          type="text"
          v-model="payment.external_id"
          class="mt-4"
        ></v-text-field>
        <v-textarea
          :label="$t('paymentFormComment')"
          dense
          v-model="payment.comment"
          rows="1"
          auto-grow
          class="mt-4"
        ></v-textarea>
        <small>* {{ $t("validation") }}</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="closeForm()">{{
          $t("btnExit")
        }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="submitForm()"
          :disabled="$v.payment.$invalid"
          >{{ $t("btnCreate") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  name: "PaymentsForm",

  mixins: [validationMixin],

  props: ["paymentForm"],

  data() {
    return {
      payment: {
        purchase: null,
        external_id: null,
        comment: null,
      },
    };
  },

  validations: {
    payment: {
      purchase: {
        required,
        maxLength: maxLength(10),
      },
    },
  },

  computed: {
    paymentPurchaseErrors() {
      const errors = [];
      if (!this.$v.payment.purchase.$dirty) return errors;
      !this.$v.payment.purchase.required &&
        errors.push(this.$i18n.t("validationSum"));
      !this.$v.payment.purchase.maxLength &&
        errors.push(this.$i18n.t("validationPaymentsLength"));
      return errors;
    },
  },

  methods: {
    ...mapActions(["setPayment"]),
    submitForm() {
      this.setPayment(this.payment).then((response) => {
        this.$emit("reload-payments");
        this.$emit("close-dialog");
      });
    },
    closeForm() {
      this.$emit("close-dialog");
    },
  },

  watch: {
    paymentForm(visible) {
      if (!visible) {
        this.$v.$reset();
      }
    },
  },
};
</script>
